import { SetStateAction, useAtomValue, useSetAtom } from 'jotai'

import { closeSidebarAtom, sidebarAtom } from '../atoms/sidebar'
import { SidebarType } from '../types/Sidebar'
import { SidebarState, SidebarStateBookingEdit } from '../types/SidebarStates'

interface UseSidebarReturn {
  // Current sidebar state
  sidebar: SidebarState

  // Set sidebar state
  setSidebar: (update: SetStateAction<SidebarState>) => void

  // Replace the booking shown in the booking edit sidebar; no-op for any other sidebar
  updateBooking: (booking: SidebarStateBookingEdit['booking']) => void

  // Close sidebar (convenience function)
  closeSidebar: () => void
}

/**
 * Hook for managing sidebar state.
 *
 * This hook provides access to sidebar atoms for components
 * that need to control sidebar visibility and content.
 */
export const useSidebar = (): UseSidebarReturn => {
  const sidebar = useAtomValue(sidebarAtom)
  const setSidebar = useSetAtom(sidebarAtom)
  const closeSidebar = useSetAtom(closeSidebarAtom)

  const updateBooking: UseSidebarReturn['updateBooking'] = (booking) =>
    setSidebar((prev) =>
      prev.open && prev.type === SidebarType.BOOKING_EDIT ? { ...prev, booking } : prev
    )

  return {
    sidebar,
    setSidebar,
    updateBooking,
    closeSidebar,
  }
}
